import React from "react";

const VARIANTS = {
  success: { badge: "✓", badgeClass: "bg-emerald-500" },
  empty: { badge: null, badgeClass: "" },
  denied: { badge: "!", badgeClass: "bg-red-500" },
  notfound: { badge: "?", badgeClass: "bg-amber-500" },
};

export const EagleState = ({ variant = "empty", title, message, actionLabel, onAction, testId }) => {
  const v = VARIANTS[variant] || VARIANTS.empty;

  return (
    <div className="flex flex-col items-center text-center py-10 px-4" data-testid={testId || `eagle-state-${variant}`}>
      <div className="relative mb-4">
        <img
          src="/yokolicious-eagle-salute.png"
          alt="YOKOLICIOUS mascot"
          className={`h-20 w-20 object-contain ${variant === "empty" ? "opacity-70" : ""}`}
        />
        {v.badge && (
          <span className={`absolute -bottom-1 -right-1 w-6 h-6 rounded-full ${v.badgeClass} text-white text-xs font-bold flex items-center justify-center border-2 border-white`}>
            {v.badge}
          </span>
        )}
      </div>
      <h3 className="text-base font-bold text-gray-800 mb-1">{title}</h3>
      <p className="text-sm text-gray-500 max-w-sm">{message}</p>
      {actionLabel && onAction && (
        <button
          data-testid={`${testId || variant}-action-button`}
          onClick={onAction}
          className="mt-4 px-5 py-2 rounded-full bg-blue-600 text-white text-sm font-semibold hover:bg-blue-700 active:scale-95 transition-all"
        >
          {actionLabel}
        </button>
      )}
    </div>
  );
};
